import { Col, Form, Modal, Row, Select } from 'antd'
import { generateSelectOptions } from 'modules/core/utils'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const SelectDimensionModal = ({
  visible,
  onClose,
  setDataDimensions,
  setDimensionId,
  valuesSelected,
  allDimensionsList,
}) => {
  const [form] = Form.useForm()
  const { t } = useTranslation()

  useEffect(() => {
    if (visible && allDimensionsList.length > 0) {
      form.setFieldsValue({
        dimensionList: allDimensionsList.map((dim) => ({
          dimension: dim.id,
          dimensionValue: undefined,
        })),
      })
    }
  }, [visible, allDimensionsList, form])

  const onCancel = () => {
    form.resetFields()
    setDimensionId(null)
    onClose()
  }

  const onConfirm = () => {
    form.validateFields().then((values) => {
      const data = values.dimensionList.reduce(
        (acum, data) => (acum = { ...acum, [data.dimension]: data.dimensionValue }),
        {},
      )
      setDataDimensions(data)
      onCancel()
    })
  }

  return (
    <Modal
      title={t('PLANNING_SAC_COMBINATION_DIMENSIONS_STEP_DESCRIPTION')}
      visible={visible}
      onCancel={onCancel}
      okText={t('ACTION_SAVE')}
      onOk={onConfirm}
      centered
      forceRender
      destroyOnClose
      width={720}
      bodyStyle={{ overflowY: 'auto', maxHeight: 400 }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          dimensionList: allDimensionsList.map((dim) => ({
            dimension: dim.id,
            dimensionValue: undefined,
          })),
        }}
      >
        {() => (
          <Form.List name="dimensionList">
            {(fields) => {
              return (
                <div>
                  {fields.map((field) => {
                    const dimensionId = form.getFieldValue('dimensionList')[field.name]?.dimension
                    return (
                      <Row gutter={24} key={field.key}>
                        <Col span={9}>
                          <Form.Item
                            name={[field.name, 'dimension']}
                            label={t('FIELD_DIMENSION')}
                            rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
                          >
                            <Select
                              disabled
                              options={generateSelectOptions({
                                options: allDimensionsList.map((el) => {
                                  return { id: el.id, name: el.name_destination }
                                }),
                              })}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={15}>
                          <Form.Item
                            name={[field.name, 'dimensionValue']}
                            label={t('FIELD_DIMENSION_VALUES')}
                            rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
                          >
                            <Select
                              placeholder={t('ACTION_SELECT')}
                              allowClear
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              options={generateSelectOptions({
                                options:
                                  dimensionId && valuesSelected[dimensionId]
                                    ? valuesSelected[dimensionId].map((el) => {
                                        return {
                                          code: el.code_destination,
                                          name: el.name_destination,
                                          id: el.id,
                                        }
                                      })
                                    : [],
                              })}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )
                  })}
                </div>
              )
            }}
          </Form.List>
        )}
      </Form>
    </Modal>
  )
}

export default SelectDimensionModal
